<template>
  <div v-if="photoURL" class="image preview floatable-preview">
    <b-image
      class="preview__image"
      :src="photoURL"
      ratio="1by1"
      :rounded="true"
    />
    <b-icon
      class="floating-camera-icon"
      icon="camera"
      @click.native="iconButtonClicked"
    />
  </div>
</template>

<script>
import IconUploadModal from '@/components/Organisms/IconUploadModal';

export default {
  name: 'PhotoPreview',
  props: ['value', 'currentSrc'],
  computed: {
    photoFile: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
    photoURL: {
      get() {
        if (!this.photoFile) {
          return this.currentSrc;
        }
        return URL.createObjectURL(this.photoFile);
      }
    }
  },
  methods: {
    onFileChange(inputFile) {
      this.photoFile = inputFile;
    },
    iconButtonClicked() {
      this.$buefy.modal.open({
        component: IconUploadModal,
        parent: this,
        hasModalCard: true,
        trapFocus: true,
        events: {
          uploaded: value => {
            this.onFileChange(value);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/profile-edit.scss';

.floatable-preview {
  position: relative;
}

.floating-camera-icon {
  position: absolute;
  background-color: rgba(256, 256, 256, 0.75);
  border-radius: 50%;
  bottom: 8%;
  right: 8%;
  padding: 8%;
}
.floating-camera-icon:hover {
  cursor: pointer;
}
</style>
